import React, { Component } from "react";
import RenderTable from "../common/table";
import { Icon, Label } from "semantic-ui-react";
import auth from "../../services/authService";

class SalaryTable extends Component {
  columns = [
    {
      path: "id",
      label: "Id",
      width: "2",
    },
    {
      path: "work_date",
      label: "Salary Date",
      width: "6",
    },
    {
      path: "entry_date",
      label: "Entry Date",
      width: "6",
    },

    {
      key: "actions",
      width: "2",
      content: (type) => (
        <div>
          <Icon
            name="info"
            color="info"
            className="clickable"
            onClick={() => this.props.onDetail(type)}
          />
          {auth.getCurrentUser().role === "client" && (
            <Icon
              name="edit"
              color="blue"
              className="clickable"
              onClick={() => this.props.onUpdate(type)}
            />
          )}
        </div>
      ),
    },
  ];

  render() {
    const { types, onSort, sortColumn } = this.props;

    return (
      <RenderTable
        columns={this.columns}
        data={types}
        sortColumn={sortColumn}
        onSort={onSort}
      />
    );
  }
}

export default SalaryTable;
